var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconViewHeadline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.667969 12.4997V10.1663H19.3346V12.4997H0.667969ZM0.667969 17.1663V14.833H19.3346V17.1663H0.667969ZM0.667969 7.83301V5.49967H19.3346V7.83301H0.667969ZM0.667969 3.16634V0.833008H19.3346V3.16634H0.667969Z",
    fill: "#484D63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViewHeadline);
export default __webpack_public_path__ + "static/media/icon_view_headline.53adbd3e36e7e010e476cfdc304b1910.svg";
export { ForwardRef as ReactComponent };